import { useState, useCallback, useEffect } from 'react';
import { SPSyncGrantResult, reconcileGrant } from '../../../api/v2/SPSyncApi';
import { useAppContext } from '../../shared/AppContext';
import { useFilteredRows } from './useFilteredRows';

export const useSPSyncDetailController = (grantId: string | undefined) => {
    const app = useAppContext();

    const [grantResult, setGrantResult] = useState<SPSyncGrantResult | null>(null);
    const [loading, setLoading] = useState(false);
    const [showOnlyDiffs, setShowOnlyDiffs] = useState(false);

    const loadGrant = useCallback(async () => {
        if (!grantId) return;
        setLoading(true);
        try {
            const res = await reconcileGrant(grantId);
            if (res?.error) {
                app.errorToast(res.error.message);
                return;
            }
            setGrantResult(res?.data ?? null);
        } finally {
            setLoading(false);
        }
    }, [grantId]);

    useEffect(() => {
        loadGrant();
    }, [loadGrant]);

    const result = grantResult?.result ?? null;

    const filteredRows = useFilteredRows(result?.rows, showOnlyDiffs);

    return {
        isSuper: app.UserIsSuper,
        grantResult,
        result,
        loading,
        showOnlyDiffs,
        setShowOnlyDiffs,
        filteredRows,
        reload: loadGrant
    };
};
